<template>
  <div class="portlet-container">
    <div class="c_ontent-container" style="p_adding: 1.5rem;">

      <div class="hello">
        <h1>{{ msg }}</h1>

        <div>
          <h2>{{ $t('user.my-roles') }}:</h2>
          <ul class="ul-inline">
            <li v-for="role in currentUser.roles">{{ getRoleLabel(role) }}</li>
          </ul>
          <el-divider/>
        </div>

        <div v-permission="['ADMINISTRATION']">
          <div>
            <span style="font-size: 1.5em;">{{ $t('version') }}:&nbsp;</span>
            {{ $store.getters.appVersion }}
          </div>
          <div>
            <span style="font-size: 1.5em;">{{ $t('build-date') }}:&nbsp;</span>
            {{ $store.getters.appBuildDate }}
          </div>
          <el-divider/>
        </div>

        <div v-role="['DEV']">
          <h2>Current user</h2>
          <json-print v-if="true" :value="currentUser"/>
        </div>

        <div v-if="false">
          <h4>Test icons</h4>
          <div>
            svg:
            <svg-icon class="new-item" icon-class="bug"/>
            el:
            <i class="el-icon-document-add" style="color: coral;"/>
          </div>
          <el-divider/>
        </div>

        <div v-role="['DEV']">
          <h2>Essential Links</h2>
          <ul class="ul-inline">
            <li>
              <router-link to="/flight-order-groups">[DEV] Flight Orders</router-link>
            </li>
            <li>
              <router-link to="/icons">[DEV] icons</router-link>
            </li>
            <br>
          </ul>
        </div>

        <template v-if="false">
          <h2>Ecosystem</h2>
          <ul>
            <li>
              <a href="http://vuejs-templates.github.io/webpack/" target="_blank">Docs for This Template</a>
            </li>
            <li>
              <a href="http://router.vuejs.org/" target="_blank">vue-router</a>
            </li>
            <li>
              <a href="http://vuex.vuejs.org/" target="_blank">vuex</a>
            </li>
            <li>
              <a href="http://vue-loader.vuejs.org/" target="_blank">vue-loader</a>
            </li>
            <li>
              <a href="https://github.com/vuejs/awesome-vue" target="_blank">awesome-vue</a>
            </li>
          </ul>
        </template>

        <div v-role="['DEV']">
          <h2>Actions</h2>
          <el-button v-loading="loading" @click="updateDbCache" size="mini">
            <svg-icon icon-class="edit"/> update DB cache
          </el-button>
          <div v-if="false">
            <el-button @click="logout" type="primary" size="small">{{$t('navbar.logOut')}}</el-button>
            <el-button @click="ping" size="mini" class="compact labeled icon" icon="user">
              <svg-icon icon-class="edit"/>
              Ping rest
            </el-button>
            <el-button @click="parallelRest" size="xsmall" icon="el-icon-share">parallelRest</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// npm
import {Message} from 'element-ui'
//
import { autodestroyModules, autoinitModules } from '@/store'
// rest
import adminSystemRest from '@/rest/admin/system'
import pingRest from '@/rest/ping'
import loginRest from '@/rest/login'
// utils
import {hasRole} from '@/utils/user'
import {getRoles} from "@/rest/roles";

export default {
  name: 'HelloWorld',
  data() {
    return {
      loading: false,

      value: '',
      roleList: []
    }
  },
  computed: {
    currentUser() {
      const user = this.$store.getters.user

      return {
        id: user.id,
        name: user.name,
        username: user.username,
        tenant: user.tenant,
        roles: user.roles,
        permissions: user.permissions,
        isPlanner: hasRole('PLANNER'),
        isInitiator: hasRole('INITIATOR'),
        isSecurity: hasRole('SECURITY_SERVICE'),
        lang: this.$store.getters.getLanguage,
        isLanguageEn: this.$store.getters.isLanguageEn
      }
    },
    msg() {
      return this.$t('user.hello-message-X', {name: this.currentUser.name})
    }
  },
  created() {
    getRoles().then(r => {
      this.roleList = r
    })
  },
  methods: {
    async logout() {
      await this.$store.dispatch('user/logout', {router: this.$router})
      this.$router.push(`/login?redirect=${this.$route.fullPath}`)
    },
    updateDbCache () {
      this.loading = true
      console.log('updateDbCache')
      adminSystemRest.updateDbCache().then(() => {
        return autodestroyModules() // call destroy to reset stored data
      }).then(() => {
        return autoinitModules()
      }).finally(() => {
        this.loading = false
      })
    },
    ping() {
      console.log('ping')
      pingRest.ping().then((response) => {
        console.log('response: %o', response)
      }).catch((error) => {
        console.error('ping error: %o', error)
        //Message.error(error.message || 'Ping failed')
      })
    },
    parallelRest() {
      console.log('parallel rest')
      let dbItemsPromise =
        new Promise(function (resolve, reject) {
          window.setTimeout(function () {
            resolve()
          }, 0)
        }).then(() => {
          return loginRest.getDbItems().then(object => {
            return new Promise(function (resolve, reject) {
              console.log('response dbItems', object)
              window.setTimeout(function () {
                resolve(object)
              }, 0)
            })
          })
        })
      let langsPromise = loginRest.getAvailableLangs().then(object => {
        return new Promise(function (resolve, reject) {
          console.log('response langs', object)
          resolve(object)
        })
      })
      Promise.all([dbItemsPromise, langsPromise]).then((values) => {
        let dbItems = values[0]
        let langs = values[1]
        console.log('dbItems: %o', dbItems)
        console.log('langs: %o', langs)
      })
    },
    getRoleLabel (value) {
      if (this.roleList.length > 0) {
        const role = this.roleList.find(roleItem => roleItem.value === value)
        if (role) {
          return role.label
        } else {
          return value
        }
      } else {
        return value
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  h1, h2 {
    font-weight: normal;
  }

  ul.ul-inline {
    list-style-type: none;
    padding: 0;
  }

  ul.ul-inline li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #42b983;
  }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue